import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-data-table',
  templateUrl: './empty-data-table.component.html',
  styleUrls: ['./empty-data-table.component.css']
})
export class EmptyDataTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
